import axios from 'axios';

const myApi = axios.create({
    baseURL: '/api-v2',
  });

export default {
  getNoticias(lang) {
    return myApi
      .get(lang + '/noticias')
      .then(response => response.data);
  },
  getNoticia(lang,idNoticia) {
    return myApi
      .get(lang+'/noticias/'+idNoticia)
      .then(response => response.data);
  },
  getCategorias(lang) {
    return myApi.get(lang + '/noticias-categorias').then(response => response.data);
  }
};